import { render, staticRenderFns } from "./MaterialList.vue?vue&type=template&id=b72c00f8&scoped=true&"
import script from "./MaterialList.vue?vue&type=script&lang=js&"
export * from "./MaterialList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialList.vue?vue&type=style&index=0&id=b72c00f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72c00f8",
  null
  
)

export default component.exports